module.exports = __webpack_public_path__ + "img/three1Blue.0cd8ae47.jpg";